module.exports = __webpack_public_path__ + "media/images/favicon-7b688775046d8732d89941b7e498b33c.ico";